import React, {useEffect, useRef, useState} from 'react';
import {ChartIcon, DataIcon} from "../../../Assets/svg";
import _axios from "../../../httpService";
import AddSection from "./AddSection";
import Swal from "sweetalert2";
import {toast} from "react-toastify";
import {useLocation, useNavigate} from "react-router-dom";
import Loader from "../../Loader";

const ReportBuilder = () => {

  // const [isLoading, setIsLoading] = useState(true)

  const tableRefLink = useRef()
  const chartRefLink = useRef()
  const location = useLocation();
  const navigateTo = useNavigate();
  let prefixUrl = localStorage.getItem("apiUrl") + "/userDashboardData/";
  const [needToReload, setNeedToReload] = useState(false)
  const [tableChartList, setTableChartList] = useState({
    chart: [],
    table: [],
  });

  const [activeTab, setActiveTab] = useState("table")
  useEffect(() => {

    // اگه برگشت زده بود این خط کد باید چک بشه

    if (location.state) {
      //debugger
      // setActiveTab(location.state.from);
      // setIsLoading(false);
      if (location.state.from === "chart") {
        chartRefLink.current.click();
      } else {
        tableRefLink.current.click();
      }
    }


    // اینجا باید درخواست بزنم بگم آقا لیست چارت ها و جداول موجود رو بده
    _axios.get(prefixUrl + "?request=definedReports").then((response) => {
      // setTableChartList({
      //   chart: [
      //     {id: 0, title: "فروش ماه و سال", color: "#6ACBD8"},
      //     {id: 2, title: "نمودار فروش کلی فروشگاه من", color: "#F8B27F"},
      //     {id: 2, title: "نمودار فروش کلی فروشگاه من", color: "#F8B27F"},
      //     {id: 3, title: "من در این تاریکی فکر یک بره روشن هستم که بیاید علف خستگی‌ام را بچرد", color: "#86D593"},
      //   ],
      //   table:response.data.table,
      // });
      setTableChartList(response.data)

    })
  }, [needToReload])

  const addTableHandler = () => {
    navigateTo("/define-new-data-chart", {
      state: {type: "table", id: undefined, mode: "add"},
    });
  }

  const editTableHandler = (id, title) => {
    navigateTo("/define-new-data-chart", {
      state: {type: "table", id: id, mode: "edit", title: title},
    });
  }
  const deleteTableHandler = (id, title) => {
    Swal.fire({
      title: "حذف جدول ",
      text: `آیا از حذف جدول  «${title}»     مطمئنید؟`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'بله',
      cancelButtonText: 'خیر'
    }).then((result) => {
      if (result.isConfirmed) {

        // const tempTableChartList = {...tableChartList}
        // tempTableChartList.table = tempTableChartList.table.filter((v, index) => v.id !== id);
        // setTableChartList(tempTableChartList);

        //اینجا یه درخواست میزنم میگم این جدول با این آیدی رو حذف کن
        // توی نتیجه درخواست دوباهر میگم آقا جداول رو بده

        _axios.delete(prefixUrl, {
          data: {
            id: id,
            request: "deleteReport"
          }
        }).then((response) => {
          if (response.data.status) {
            setNeedToReload(ps => !ps);
            toast.success(response.data.message);
          } else {
            Swal.fire({
              title: response.data.message,
              icon: 'error',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'باشه',
            })
          }
        })

      }


    })


  }

  const addChartHandler = () => {
    navigateTo("/define-new-data-chart", {
      state: {type: "chart", id: undefined, mode: "add", title: undefined},
    });
  }
  const editChartHandler = (id, title) => {
    navigateTo("/define-new-data-chart", {
      state: {type: "chart", id: id, mode: "edit", title: title},
    });
  }
  const deleteChartHandler = (id, title) => {
    Swal.fire({
      title: "حذف نمودار ",
      text: `آیا از حذف نمودار  «${title}»     مطمئنید؟`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'بله',
      cancelButtonText: 'خیر'
    }).then((result) => {
      if (result.isConfirmed) {
        //اینجا یه درخواست میزنم میگم این جدول با این آیدی رو حذف کن
        // توی نتیجه درخواست دوباهر میگم آقا جداول رو بده
        _axios.delete(prefixUrl, {
          data: {
            id: id,
            request: "deleteReport"
          }
        }).then((response) => {
          if (response.data.status) {
            setNeedToReload(ps => !ps);
            toast.success("نمودار با موفقیت حذف شد.")
          } else {
            Swal.fire({
              title: response.data.message,
              icon: 'error',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'باشه',
            })
          }
        })

      }
    })

  }


  return (
    <div className={"p-2 "}
         style={{"width": "100%", "height": "88vh", "overflow": "scroll"}}
    >
      {
        <section className="py-4 setting">
          <div className="container-fluid">
            <div className="bg-white rounded-lg d-block">
              <div className="profile-tab-nav d-flex justify-content-center">
                <ul className="nav nav-pills customStyleNavPills" role="tablist">
                  <li className="nav-item">
                    <a
                      // className={"nav-link CustomStyleNavPills__nav_link " + activeTab==="table" ? " active " : ""}
                      // className={"nav-link CustomStyleNavPills__nav_link active"}
                      className={activeTab === "table" ? " nav-link CustomStyleNavPills__nav_link active " : "nav-link CustomStyleNavPills__nav_link"}
                      id="table-tab"
                      data-bs-toggle="pill"
                      href="#tableDefine"
                      ref={tableRefLink}
                    >
                      <DataIcon/>
                      <span className={"mx-3"}>
                    جدول
                  </span>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      // className={"nav-link CustomStyleNavPills__nav_link"+ activeTab==="chart" ? " active " : ""}
                      // className={"nav-link CustomStyleNavPills__nav_link"}
                      className={activeTab === "chart" ? " nav-link CustomStyleNavPills__nav_link active " : "nav-link CustomStyleNavPills__nav_link"}

                      id="chart-tab"
                      data-bs-toggle="pill"
                      href="#chartDefine"
                      ref={chartRefLink}

                    >
                      <ChartIcon/>
                      <span className={"mx-3"}>
                    چارت
                    </span>
                    </a>
                  </li>
                </ul>
              </div>
              <div className={"d-flex justify-content-center"} style={{
                'width': '1200px',
                'margin': '0 auto',
                overflow: 'scroll'
              }}>
                <div className="tab-content p-4 p-md-5">
                  {/*AddTable*/}
                  <div className="tab-pane  active" id="tableDefine">
                    <AddSection
                      entity={"table"}
                      data={tableChartList.table}
                      add={addTableHandler}
                      onEdit={editTableHandler}
                      onDelete={deleteTableHandler}
                    />
                  </div>
                  {/*AddChart*/}
                  <div className="tab-pane fade" id="chartDefine">
                    <AddSection
                      entity={"chart"}
                      data={tableChartList.chart}
                      add={addChartHandler}
                      onEdit={editChartHandler}
                      onDelete={deleteChartHandler}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      }


    </div>
  );
};

export default ReportBuilder;
